<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container">
	<div class="header-container">
		<div class="hi-container">
			<p class="title font-serra">Bienvenue 👋</p>
			<p class="subtitle">Ta légende, ta collection</p>
		</div>
		<div class="avatar-container">

	      <!-- drawer -->
	      <div class="drawer drawer-end">
	        <input #drawer id="drawer-menu-user" type="checkbox" class="drawer-toggle" />
	        <label for="drawer-menu-user">
			  <lgb-avatar [clickable]="false"></lgb-avatar>
	        </label>
	        <div class="drawer-side">
	          <label for="drawer-menu-user" aria-label="close sidebar" class="drawer-overlay"></label>
	          <ul class="admin-menu menu bg-base-200 min-h-full w-80 p-4 text-lg">
	            <li>
	                <a (click)="drawer.checked=false" href="#" [routerLink]="router.get('my-share')" routerLinkActive="menu-active">
	                  <i class="fa-light fa-paper-plane"></i> Mes partages
	                </a>
	            </li>
	            <li>
	                <a (click)="drawer.checked=false" href="#" [routerLink]="router.get('my-acount')" routerLinkActive="menu-active">
	                  <i class="fa-light fa-user-gear"></i> Mon compte
	                </a>
	            </li>
	            <li>
	                <a (click)="drawer.checked=false" href="#" [routerLink]="router.get('my-options')" routerLinkActive="menu-active">
	                  <i class="fa-light fa-gears"></i> Paramètres
	                </a>
	            </li>
	            <li>
	                <a (click)="unlog()" href="#" class="text-error" [routerLink]="router.get('my-options')" routerLinkActive="menu-active">
						<i class="fa-light fa-power-off"></i> Deconnexion
	                </a>
	            </li>
	          </ul>
	          <div class="version">
	        	{{globalS.getVersion()}}
	          </div>
	        </div>
	      </div>
		</div>
	</div>
	<div class="search-container">
		<label (click)="router.navigate('card-search')" class="input input-bordered input-lg w-full gap-2">
		  <input type="text" class="grow placeholder:text-base-content/60" placeholder="Recherchez une carte..." />
		  <span class="opacity-60"><i class="fa-light fa-sliders"></i></span>
		</label>
	</div>
	<div class="title-xs font-serra">
		Votre collection
	</div>
	<div class="menu-container">
		<a [routerLink]="router.get('collect-binders')" routerLinkActive="btn-primary" class="btn">
			<i class="fa-light fa-rectangle-vertical-history pr-1"></i>
			Binders
		</a>
		<a [routerLink]="router.get('collect-cards')" routerLinkActive="btn-primary" class="btn">
			<i class="fa-light fa-cards-blank pr-1"></i>
			Cartes
		</a>
		<a [routerLink]="router.get('collect-favorites')" routerLinkActive="btn-primary" class="btn">
			<i class="fa-light fa-bookmark pr-1"></i> Favoris
  		</a>
	</div>
	<router-outlet />
</div>